import { render, staticRenderFns } from "./BundlePurchaseOptionCard.vue?vue&type=template&id=72e7a46a&scoped=true"
import script from "./BundlePurchaseOptionCard.vue?vue&type=script&lang=ts"
export * from "./BundlePurchaseOptionCard.vue?vue&type=script&lang=ts"
import style0 from "./BundlePurchaseOptionCard.vue?vue&type=style&index=0&id=72e7a46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7a46a",
  null
  
)

export default component.exports